module.exports = __webpack_public_path__ + "img/beeldschermbril-scherm.fcf94fd3.svg";